import React, { useState } from 'react';
import { Card } from 'antd';
import { Image, Space } from 'antd';

const { Meta } = Card;

export function PropertyCard({ imageUrl, title }) {
  return (
    <Card
      hoverable
      style={{
        width:'420px',
        height:'auto',
        margin:'0 0 2rem 0',
        border: '2px solid',
        borderColor:'lightsilver'
      }}
      className='propertycard'
      cover={<img alt="property" src={imageUrl} />}
    >
      <Meta
        title={<div style={{ 
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '1.1rem', 
          fontWeight: 'bold', 
          whiteSpace: 'wrap', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          display:'flex', 
          flexDirection:'row', 
          justifyContent:'center', 
          alignContent:'center',
          textAlign:'center'
        }}>{title}</div>}
        style={{ display:'flex', flexWrap:'wrap', padding: '0 0 0 0' }}
      />
    </Card>
  );
}


export function CertificateCard({ imageUrl, title }) {
  return (
    <Card
      hoverable
      style={{
        width:'360px',
        height:'auto',
        margin:'0 2rem',
        border: '2px solid grey',
      }}
      className='propertycard'
      cover={<img alt="property" src={imageUrl} />}
    >
      <Meta
        title={<div style={{ 
          fontFamily: 'Montserrat, sans-serif',
          // fontSize: '1.1rem', 
          fontWeight: '300', 
          whiteSpace: 'wrap', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis', 
          display:'flex', 
          flexDirection:'row', 
          justifyContent:'center', 
          alignContent:'center' 
        }}>{title}</div>}
        style={{ display:'flex', flexWrap:'wrap', padding: '0 0 0 0' }}
      />
    </Card>
  );
}


export function InfoTitle({ className, title, value }) {
    return (
      <div className={`${className} info-title`} style={{ width:'auto', padding:'1rem 1rem'}}>
        <div className='info-title__value'>
          <img src={value} alt={title} style={{ width:'570px', maxWidth: '100%', height: 'auto', padding:'0' }} />
        </div>
        <div className='info-title__title' style={{ padding:'0 1rem', fontSize:'1.5rem', fontWeight:'bolder', display:'flex', justifyContent:'center', flexWrap:'wrap' }}>
          {title}
        </div>
      </div>
    );
}  





export function PreviewCard() {
  const [random] = useState();

  return (
    <Space size={12}>
      <Image
        width={200}
        src={process.env.PUBLIC_URL + '/images/KS_logo.png'}
        placeholder={
          <Image
            preview={false}
            src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200"
            width={200}
          />
        }
      />
    </Space>
  );
};